<template>
  <button
    v-bind="$attrs"
    class="relative inline-flex h-5 w-5 items-center justify-center"
  >
    <span class="sr-only">Open main menu</span>
    <span
      class="absolute inline-block h-0.5 w-6 bg-neutral-900 transition-transform duration-300 ease-in-out xl:w-5"
      :class="[isOpen ? '-rotate-45' : '-translate-y-1.5']"
      aria-hidden="true"
    />
    <span
      class="absolute inline-block h-0.5 w-6 bg-neutral-900 transition-[opacity,visibility] duration-300 ease-in-out xl:w-5"
      :class="[isOpen ? 'opacity-0' : 'opacity-100']"
      aria-hidden="true"
    />
    <span
      class="absolute inline-block h-0.5 w-6 bg-neutral-900 transition-transform duration-300 ease-in-out xl:w-5"
      :class="[isOpen ? 'rotate-45' : 'translate-y-1.5']"
      aria-hidden="true"
    />
  </button>
</template>

<script setup>
defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
})
</script>
